/* eslint-disable @typescript-eslint/no-unused-vars */
'use client';
import * as X from "@/ui";

import Hero1Image from "@/assets/bucket/about-us-hero-1.png";
import Hero2Image from "@/assets/bucket/about-us-hero-2.png";
import FoundersMobileImage from "@/assets/bucket/about-us-founders-mobile.png";
import FoundersDesktopImage from "@/assets/bucket/about-us-founders-desktop.png";
import { useAboutUsPage } from "@/providers/strapi/content/types/singleTypes/about-us-page";
import ReactMarkdown from "react-markdown";


// const data = {
//   founders: {
//     p: [
//       {
//         en: "Founded in 2017 by a team of French and Belgian entrepreneurs, Zapptax developed a fully digital solution that enables non-EU residents to claim VAT refunds in a simple, fast, and transparent way.",
//         fr: "Fondée en 2017 par une équipe d’entrepreneurs franco-belges, l’entreprise a mis au point une solution 100% digitale qui permet aux résidents hors UE de détaxer leurs achats de manière simple, rapide et transparente.",
//       },
//       {
//         en: "Since its launch in 2018 as the first digital tax-free operator, Zapptax has helped travelers from over 100 countries recover tens of millions of euros on their purchases.",
//         fr: "Depuis son lancement en 2018 en tant que premier opérateur de détaxe digital, Zapptax a aidé des voyageurs de plus de 100 pays à récupérer des dizaines de millions d’euros sur leurs achats.",
//       },
//       {
//         en: "Today,  Zapptax stands as an innovative alternative to traditional tax-free operators, with one clear mission: to give travelers back what’s rightfully theirs - the VAT on their purchases - and to transform the industry by putting both travelers and retailers at the heart of the system.",
//         fr: "La société s’est imposée comme une alternative innovante aux acteurs traditionnels de la détaxe. Avec une ambition claire : rendre aux voyageurs ce qui leur est dû (la TVA sur leurs achats) et continuer à révolutionner le secteur en plaçant les voyageurs et les commerçants au cœur du système.",
//       },
//     ],
//     who: {
//       en: "Jean-Marie Wodon & Thomas Roussarie",
//       fr: "Jean-Marie Wodon et Thomas Roussarie",
//     },
//     role: {
//       en: "Co-founders of Zapptax",
//       fr: "Co-fondateur de Zapptax",
//     },
//   },
// };


export function StorySection(_props: X.PageProps) {
  // const tr = X.useTranslator();

  const title = useAboutUsPage('title');
  const content = useAboutUsPage('content');
  const images = useAboutUsPage('images');
  return (
    <section className="relative w-full mb-16 xl:mb-20">
      <h1 className="xl:text-center text-[36px] xl:text-[64px] [&_strong]:font-medium mx-mobile-margin xl:max-w-4xl xl:mx-auto">
        {/* {tr({
          en: <>Our <strong>Story</strong></>,
          fr: <>Notre <strong>histoire</strong></>,
        })} */}
        {/* {title} */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <>{props.children}</>,
          h1: ({ ...props }) => <>{props.children}</>,
          h2: ({ ...props }) => <>{props.children}</>,
          h3: ({ ...props }) => <>{props.children}</>,
          h4: ({ ...props }) => <>{props.children}</>,
          h5: ({ ...props }) => <>{props.children}</>,
        }}>
          {title}
        </ReactMarkdown>
      </h1>

      <div className="my-10 mx-mobile-margin xl:max-w-4xl xl:mx-auto text-[16px] xl:text-[24px] font-medium xl:font-normal [&_strong]:font-medium leading-tight xl:text-center flex flex-col gap-2">
        <ReactMarkdown>{content}</ReactMarkdown>

        {/* <p>

          {tr({
            en: <>Zapptax was born out of a frustration shared by many international travelers: <strong>the complexity and financial loss tied to getting VAT refunds when shopping in Europe.</strong></>,
            fr: <>Zapptax est née du constat d’une frustration bien connue des voyageurs internationaux{X.Nbsp}: <strong>la complexité et les pertes financières liées au remboursement de la TVA lors des achats en Europe.</strong></>,
          })}
        </p> */}
      </div>

      <div className={X.clsx(X.desktopOnly("flex"), "flex flex-row max-w-content mx-auto gap-8 items-end mt-20 mb-20")}>
        <div className="flex-1 flex flex-col items-stretch">
          {/* <X.Image
            src={Hero1Image}
            alt="Story 1"
            className={X.clsx("rounded-xl h-auto")}
            priority
          /> */}
          {images[0] && <X.Image
            src={images[0].url}
            width={images[0].width}
            height={images[0].height}
            alt="Story 1"
            className={X.clsx("rounded-xl h-auto")}
            unoptimized
          />}
        </div>
        <div className="flex-initial w-[40%] flex flex-col items-stretch">
          {/* <X.Image
            src={Hero2Image}
            alt="Story 2"
            className={X.clsx("rounded-xl h-auto")}
            priority
          /> */}
          {images[1] && <X.Image
            src={images[1].url}
            width={images[1].width}
            height={images[1].height}
            alt="Story 1"
            className={X.clsx("rounded-xl h-auto")}
            unoptimized
          />}
        </div>
      </div>

      <FoundersMobile />
      <FoundersDesktop />
    </section>
  );
}


function FoundersDesktop() {
  // const tr = X.useTranslator();
  const coFounderCard = useAboutUsPage('coFounderCard')
  return (
    <div className={X.clsx(
      X.desktopOnly("flex"),
      "bg-surface-blue p-8 pt-16 flex-row gap-16 max-w-content mx-auto mb-20 rounded-4xl",
    )}>
      <div className="flex-1 flex flex-col gap-6 text-[20px]">
        <ReactMarkdown>
          {coFounderCard.content}
        </ReactMarkdown>
        {/* {data.founders.p.map((text, i) => (
          <p key={i} className="text-[20px]">{tr(text)}</p>
        ))}
        <p className="text-[20px] [&_strong]:font-bold">
          <strong>{tr(data.founders.who)}</strong><br />
          {tr(data.founders.role)}
        </p> */}
      </div>

      <div className="flex-1">
        {/* <X.Image
          src={FoundersDesktopImage}
          alt="Founders"
          className=""
        /> */}
        <X.Image
          src={coFounderCard.picture.url}
          width={coFounderCard.picture.width}
          height={coFounderCard.picture.height}
          alt="Founders"
          unoptimized
          className="rounded-xl"
        />
      </div>
    </div>
  );
}


function FoundersMobile() {
  // const tr = X.useTranslator();
  const coFounderCard = useAboutUsPage('coFounderCard')
  return (
    <div className={X.clsx(
      X.mobileOnly(),
      "relative mt-[55vw]",
    )}>
      <div className="mx-mobile-margin">
        {/* <X.Image
          src={FoundersMobileImage}
          alt="Founders"
          className="-translate-y-[50vw]"
        /> */}
        <X.Image
          src={coFounderCard.picture.url}
          width={coFounderCard.picture.width}
          height={coFounderCard.picture.height}
          alt="Founders"
          unoptimized
          className="rounded-xl -translate-y-[50vw]"
        />
      </div>

      <div className={X.clsx(
        "flex-1 flex flex-col gap-6 -mt-[80vw] pt-[35vw]",
        "mr-mobile-margin-half bg-surface-blue pl-mobile-margin pr-mobile-margin-half rounded-tr-2xl pb-10",
      )}>
        <ReactMarkdown>
          {coFounderCard.content}
        </ReactMarkdown>
        {/* {data.founders.p.map((text, i) => (
          <p key={i} className="text-[16px]">{tr(text)}</p>
        ))}
        <p className="text-[16px] [&_strong]:font-bold">
          <strong>{tr(data.founders.who)}</strong><br />
          {tr(data.founders.role)}
        </p> */}
      </div>
    </div>
  );
}
